import Affix from './Affix';
export default Affix;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-affix/src/index.js